/**
 * Contains functionality to download a certain content from the backend.
 * This common functionality was introduced, as using "location.href=" advises to not work in all browsers.
 * I.e. when Firefox download dialog is shown window.location.href is changed and Firefox closes all open web sockets making DICOM viewer unresponsive (analyzed by Jakub Chalmovsky in SENSE-15554).
 *
 * @packageDocumentation
 */

export function download(url: string): void {
  const downloadLink = document.createElement('a');
  downloadLink.href = encodeURI(url);
  downloadLink.className = 'hidden';
  downloadLink.download = '';
  downloadLink.click();
}

/**
 * Makes an untrusted file name safe for the `download` attribute: removes
 * path separators and control characters, falls back to `download`.
 */
export function sanitizeDownloadFileName(fileName: string | undefined): string {
  const cleaned = (fileName ?? '')

    .replace(/[\\/\u0000-\u001f\u007f]/g, '')
    .trim();
  return cleaned === '' || /^\.+$/.test(cleaned) ? 'download' : cleaned;
}

/**
 * Downloads a `blob:` URL under the given file name.
 * The URL is only downloaded, never opened, so the content cannot run in our origin.
 */
export function downloadBlobUrl(url: string, fileName: string): void {
  const downloadLink = document.createElement('a');
  downloadLink.href = url;
  downloadLink.className = 'hidden';
  downloadLink.download = sanitizeDownloadFileName(fileName);
  downloadLink.click();
}
